const GERSHAIM_REGEXP = /["״׳'`-]/g;

export const removeGershaim = (streetName = '') => streetName.replace(GERSHAIM_REGEXP, '');
